import type { ReactNode } from 'react';
import { Card, CardHeader } from '../primitives/Card.tsx';

export interface TableCardProps {
  title: ReactNode;
  /** The count or peak opposite the title. */
  meta?: ReactNode;
  /** A link or button on the header's right, after the meta. */
  action?: ReactNode;
  /** The DataTable, and anything else that should sit flush to the card's edges. */
  children: ReactNode;
  /** For a view that places the card in a grid — the partner detail's wide column. */
  className?: string;
}

/**
 * A card whose body is a full-bleed table, with a padded header above it.
 *
 * This existed twelve times as the same six lines of JSX — a `<Card pad="0">`, a
 * one-declaration `<div className="{view}Head">` restoring the padding the header
 * still needs, a `<CardHeader>`, and the table — backed by seven byte-identical
 * `padding: 20px 20px 0` rules in seven view stylesheets. All of them were doing this.
 */
export function TableCard({ title, meta, action, children, className }: TableCardProps) {
  return (
    <Card pad="0" {...(className === undefined ? {} : { className })}>
      <div className="tableCardHead">
        <CardHeader
          title={title}
          {...(meta === undefined ? {} : { meta })}
          {...(action === undefined ? {} : { action })}
        />
      </div>
      {children}
    </Card>
  );
}
